<main class="terms-page min-h-screen bg-white font-sans">
  <section class="relative overflow-hidden bg-hero-gradient pb-24 text-white">
    <div class="relative z-10 flex items-center justify-between px-6 py-4 text-white sm:px-8 md:px-16 lg:px-24 lg:py-8">
      <a routerLink="/login" class="inline-flex items-center">
        <img [src]="imageEnum.WHITE_LOGO_BLUE" alt="Charaka logo" class="h-8 sm:h-10 md:h-12 lg:h-14" />
      </a>
    </div>

    <div class="relative z-10 mt-16 w-full px-6 sm:px-8 md:mt-24 md:px-14 lg:px-20 3xl:px-28">
      <div class="flex flex-col items-center justify-between gap-12 md:flex-row">
        <div class="w-full md:w-1/2">
          <h1 class="mb-4 text-[1.75rem] font-normal leading-tight tracking-wide text-white sm:text-[2rem] md:text-[2.25rem] lg:text-[2.5rem] xl:text-[2.75rem] 2xl:text-[3.25rem] 3xl:text-[3.75rem]">
            Your Agreement<br />
            <span class="font-serif text-[2.25rem] font-bold tracking-normal text-white sm:text-[2.75rem] md:text-[3.25rem] lg:text-[3.5rem] xl:text-[3.75rem] 2xl:text-[4.25rem] 3xl:text-[5rem]">
              Our Terms.
            </span>
          </h1>

          <p class="mb-10 max-w-md text-sm leading-relaxed text-[#DBDBDB] md:text-base">
            Please review our terms and conditions carefully before using our services. They outline your rights, responsibilities, and the rules for using our platform.
          </p>
        </div>

        <div class="flex w-full justify-center md:w-1/2">
          <img
            [src]="imageEnum.PRIVACY_POLICY_ICON"
            alt="Terms and conditions illustration"
            class="w-full max-w-lg object-contain drop-shadow-2xl transition-transform duration-500 ease-in-out hover:scale-105"
          />
        </div>
      </div>
    </div>
  </section>

  <section
    id="terms-content"
    class="relative z-20 w-full rounded-t-3xl bg-white px-6 py-12 shadow-sm sm:px-8 md:px-16 md:py-14 lg:px-24 lg:shadow-none"
  >
    <h2 class="mb-4 text-4xl font-bold text-[#1a1a1a] md:text-5xl">
      {{ termsConditionsData.header.title }}
    </h2>

    <p class="mb-10 max-w-4xl whitespace-pre-line text-base leading-relaxed text-gray-500 md:text-lg">
      {{ termsConditionsData.header.description }}
    </p>

    <p class="mb-6 text-lg font-bold text-[#1a1a1a] md:text-xl">
      Last Updated: {{ termsConditionsData.header.lastUpdated }}
    </p>

    <p class="mb-14 max-w-5xl whitespace-pre-line text-base leading-relaxed text-gray-500 md:text-lg">
      {{ termsConditionsData.header.introText }}
    </p>

    @for (section of termsConditionsData.sections; track section.id) {
      <div class="mb-12">
        <h3 class="mb-2 text-2xl font-bold text-[#1a1a1a] md:text-3xl">
          {{ section.id }}. {{ section.title }}
        </h3>

        @if (section.description) {
          <p class="mb-8 whitespace-pre-line text-base text-gray-500 md:text-lg">
            {{ section.description }}
          </p>
        }

        @if (section.listItems) {
          <ul class="mb-8 list-none space-y-2 pl-0 text-sm text-[#1a1a1a] md:text-base">
            @for (item of section.listItems; track $index) {
              <li>
                @if (item.boldText) {
                  <strong>{{ item.boldText }}</strong>
                }
                {{ item.text }}
              </li>
            }
          </ul>
        }

        @if (section.subsections) {
          @for (sub of section.subsections; track sub.title) {
            <div class="mb-4 md:pl-2">
              <h4 class="mb-2 text-lg text-[#1a1a1a]">
                <span class="font-bold">{{ sub.title }}</span>
                <span class="font-normal text-gray-600">{{ sub.text }}</span>
              </h4>

              @if (sub.items) {
                <ul class="mt-3 list-disc space-y-2 pl-5 text-sm text-[#1a1a1a] md:text-base">
                  @for (item of sub.items; track $index) {
                    <li>
                      @if (item.boldText) {
                        <strong>{{ item.boldText }}</strong>
                      }
                      {{ item.text }}
                    </li>
                  }
                </ul>
              }

              @if (sub.footerText) {
                <p class="mt-4 whitespace-pre-line text-base text-gray-500 md:text-lg">
                  {{ sub.footerText }}
                </p>
              }
            </div>
          }
        }

        @if (section.footerText) {
          <p class="mt-4 whitespace-pre-line text-base text-gray-500 md:text-lg">
            {{ section.footerText }}
          </p>
        }
      </div>
    }

    <p class="mt-12 whitespace-pre-line text-base font-medium text-gray-500 md:text-lg">
      {{ termsConditionsData.footerNote }}
    </p>
  </section>
</main>
